<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :style="{ height: '50%', width: '100%', zIndex: '999999' }"
  >
    <div class="pre-room-box">
      <div class="pre-room-tit">{{ title }}</div>
      <div
        v-for="(item, index) in data"
        :key="index"
        class="pre-room-item"
        @click="orderDetail(item.OrderId)"
      >
        <div class="flex">
          <div>
            <van-tag color="#199ed8" v-if="item.StatusName == '预订'"
              >订
            </van-tag>
            <van-tag v-else-if="item.StatusName == '在住'" color="#00cc99"
              >住
            </van-tag>
            <van-tag v-else-if="item.StatusName == '完成'" color="#fc0"
              >完
            </van-tag>
            <van-tag v-else-if="item.StatusName == '暂离'" color="#d544ff"
              >离
            </van-tag>
            <van-tag v-else-if="item.StatusName == '取消'" color="#999"
              >取
            </van-tag>
            <span class="item-name">
              {{ item.Contact }}
            </span>
            <span style="font-size: 12px;" v-if="item.RoomNo">
              | {{ item.RoomNo }}
            </span>
          </div>
          <div class="pre-order-no">订单号：{{ item.OrderNo }}</div>
        </div>
        <div class="pre-room-type">房型：{{ item.RoomType }}</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Cell, CellGroup, Card, Tag, Popup, Icon } from "vant";
export const PREDICTIROOMINFO = {
  Leaving: "预离", //预离
  Booking: "预订", //预入
  CheckIn: "在住", //在住
};
export default {
  name: "PredictRoomInfosPop",
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      visible: false,
      data: [],
      title: "",
    };
  },
  created() {},
  methods: {
    onShow(data, title) {
      this.title = title;
      this.visible = true;
      this.data = data;
    },
    orderDetail(id) {
      this.$router.push({ name: "OrderDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.pre-room-box {
  padding: 10px;
  .pre-room-tit {
    text-align: center;
    margin-bottom: 10px;
    font-size: 15px;
  }
  .pre-room-item {
    padding: 8px;
    margin-bottom: 8px;
    border: 1px solid #eee;
    border-radius: 3px;
    .pre-room-type {
      font-size: 12px;
      color: #666;
      margin-top: 5px;
    }
    .pre-order-no {
      font-size: 14px;
    }
  }
}
</style>
